module.exports = __webpack_public_path__ + "img/kiwify.b8f7132e.png";